import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordUpdateTitle: {
    id: 'LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_TITLE',
    defaultMessage: 'Sicherheitswarnung',
  },
  passwordUpdateSubTitle: {
    id: 'LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_SUBTITLE',
    defaultMessage: 'Bitte ändern Sie umgehend Ihr Passwort.',
  },
  passwordTooOldParagraph: {
    id: 'LOGIN_POST_LOGIN_SCREEN_PASSWORD_TOO_OLD_PARAGRAPH',
    defaultMessage:
      'Ihr Passwort ist leider veraltet und deshalb nicht mehr sicher.',
  },
  passwordUpdateEidiParagraph: {
    id: 'LOGIN_POST_LOGIN_SCREEN_PASSWORD_IN_DANGER_PARAGRAPH',
    defaultMessage:
      'Unsere Sicherheitsprüfung hat ergeben, dass Ihr XING Zugang nicht mehr geschützt ist',
  },
  passwordMoreInfoLinkText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_PASSWORD_MORE_INFO_LINK_TEXT',
    defaultMessage: 'Weitere Infos',
  },
  passwordMoreInfoLinkTarget: {
    id: 'LOGIN_POST_LOGIN_SCREEN_PASSWORD_MORE_INFO_LINK_TARGET',
    defaultMessage:
      'https://faq.xing.com/de/sicherheit/xing-sch%C3%BCtzt-ihre-nutzer-accounts-vor-identit%C3%A4tsdiebstahl',
  },
  passwordUpdateButtonText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_CTA_TEXT',
    defaultMessage: 'Passwort ändern',
  },
  advertiseTfaTitle: {
    id: 'LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_TITLE',
    defaultMessage: 'Unser Tipp: Zweiter Faktor',
  },
  advertiseTfaSubTitle: {
    id: 'LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_SUBTITLE',
    defaultMessage: 'Für noch mehr Sicherheit',
  },
  advertiseTfaParagraph: {
    id: 'LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_PARAGRAPH',
    defaultMessage:
      'Zusätzlich zu Ihrem Passwort können Sie Ihren XING Zugang mit einem zweiten Sicherheitsschritt schützen. Sie geben dann bei jedem Login nach der Eingabe des Passwortes einen einmaligen Zugangscode ein.',
  },
  advertiseTfaButtonText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_CTA_TEXT',
    defaultMessage: 'Jetzt ausprobieren',
  },
  advertiseTfaSkipButtonText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_SKIP_TEXT',
    defaultMessage: 'Überspringen',
  },
  emailBouncedTitle: {
    id: 'LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_TITLE',
    defaultMessage: 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
  },
  emailBouncedParagraph: {
    id: 'LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_PARAGRAPH',
    defaultMessage:
      'Leider können wir derzeit keine E-Mail an Ihre aktive Benachrichtigungs-Adresse {email} senden. Bitte aktualisieren Sie diese, falls sie nicht korrekt sein sollte.',
  },
  emailBouncedButtonText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_CTA_TEXT',
    defaultMessage: 'Jetzt aktualisieren',
  },
  emailBouncedSkipButtonText: {
    id: 'LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_SKIP_TEXT',
    defaultMessage: 'Überspringen',
  },
});
